import { FormControl } from '@angular/forms';

export function RequiredIfValidator(otherControlName: string): any {
  let thisControl: FormControl;
  let otherControl: FormControl;

  return function requiredIfValidate(control: FormControl): { requiredIf: { condition: any } } | undefined {
    const value = control.value;

    if (!control.parent) {
      return undefined;
    }

    if (!thisControl) {
      thisControl = control;
      otherControl = control.parent.get(otherControlName) as FormControl;
      if (!otherControl) {
        throw new Error('requiredIfValidate(): other control is not found in parent group');
      }
      otherControl.valueChanges.subscribe(() => thisControl.updateValueAndValidity());
    }

    if (!otherControl) {
      return undefined;
    }

    if (otherControl.value && !value) {
      return {
        requiredIf: { condition: otherControl.value },
      };
    }
    return undefined;
  };
}
